import { useMutation } from '@tanstack/react-query';
import {
  bulkImportService,
  type PreviewMappedParams,
  type ImportMappedParams,
} from '../services/BulkImportService.js';

export const bulkImportKeys = {
  all: ['bulkImport'] as const,
};

/** Introspects file (.xlsx, .xls, .csv) to auto-detect sheets, headers, sample values & suggested mappings */
export function useIntrospectFileMutation() {
  return useMutation({
    mutationFn: (file: File) => bulkImportService.introspectFile(file),
  });
}

/** Pre-flight dry-run validation with column mapping */
export function usePreviewMappedMutation() {
  return useMutation({
    mutationFn: (params: PreviewMappedParams) => bulkImportService.previewMapped(params),
  });
}

/** Real database commit with column mapping */
export function useImportMappedMutation() {
  return useMutation({
    mutationFn: (params: ImportMappedParams) => bulkImportService.importMapped(params),
  });
}

/** Legacy dry-run mutation */
export function usePreviewFileMutation() {
  return useMutation({
    mutationFn: (file: File) => bulkImportService.previewFile(file),
  });
}

/** Legacy import mutation */
export function useUploadFileMutation() {
  return useMutation({
    mutationFn: (file: File) => bulkImportService.uploadFile(file),
  });
}
